// extracted by mini-css-extract-plugin
export default {"control":"control_control__Rt-dL","addIcon":"control_addIcon__oAJb-"};